import React from 'react';
import { Modal } from 'antd';
import InsuranceDetailsForm from '../insuranceDetails/InsuranceDetailsForm';
import StringHelper from '../../helpers/StringHelper';
import { useGeneralStore } from '../../../store/slices/createGeneralSlice';

const faNum = StringHelper.getFarsiNum;

export default function InsuranceDetails(requestId) {

    const general = useGeneralStore();
    const visible = general.view.insuranceDetailsModal;

    return (
        <Modal
            width={'85%'}
            title={` جزئیات بیمه نامه ` + faNum(requestId.requestId)}
            className="custom-table modal-scroll cmModal"
            open={visible}
            destroyOnClose
            footer={false}
            onCancel={() => general.ToggleInsuranceDetailsModal()}>
            <InsuranceDetailsForm item={requestId} />
        </Modal>
    )
}
